import React, { FC } from 'react'
import { makeStyles } from 'transfix-ui/core'
import { CancelIcon, WarningIcon } from 'transfix-icons'
import { brandColors, Tooltip } from 'transfix-ui'

interface ValidityToolTipProps {
  /**
   * @example 23
   */
  validity: number | null
}

const useValidityToolTipStyles = makeStyles(theme => ({
  error: {
    color: brandColors.error,
    marginLeft: theme.spacing(2),
    verticalAlign: 'text-top',
  },
  warning: {
    color: brandColors.warning,
    marginLeft: theme.spacing(2),
  },
}))

export const ValidityToolTip: FC<ValidityToolTipProps> = ({ validity }) => {
  const classes = useValidityToolTipStyles()
  const DAYS_30 = 30

  if (!validity) {
    return null
  }

  if (validity < 0) {
    return (
      <Tooltip
        position='top'
        id='validity'
        trigger={<CancelIcon className={classes.error} size='medium' />}>
        Expired {Math.abs(validity)} days ago!
      </Tooltip>
    )
  }

  if (validity > 0 && validity <= DAYS_30) {
    return (
      <Tooltip
        position='top'
        id='validity'
        trigger={<WarningIcon className={classes.warning} size='medium' />}>
        Expiring in {validity} days!
      </Tooltip>
    )
  }

  return null
}
